import type Module from 'mini-common-schema/lib/schema/Module';
import { getCurrentModule } from 'mini-app-module-store/lib/selectors/getCurrentModule';
import { matchPath, useLocation } from 'mini-react-router-dom';

const mailModuleSwitcherPaths = ['/:folderId', '/:folderId/sidepane'];

const calendarModuleSwitcherPaths = [
    '/view/:mode',
    '/view/:mode/bottomsheet/:id',
    '/view/:mode/sidepane/:id',
    '/view/:mode/quickcapture',
];

const peopleModuleSwitcherPaths = ['/:folderId', '/:folderId/sidepane'];

export default function useRouteBasedVisibility(): boolean {
    const { pathname: locationPathname } = useLocation();

    switch (getCurrentModule()) {
        case 0:
            return mailModuleSwitcherPaths.some(path =>
                matchPath({ path: path, end: true }, locationPathname)
            );
        case 1:
            return calendarModuleSwitcherPaths.some(path =>
                matchPath({ path: path, end: true }, locationPathname)
            );
        case 2:
            return peopleModuleSwitcherPaths.some(path =>
                matchPath({ path: path, end: true }, locationPathname)
            );
    }

    return false;
}
